import {connect} from '../../../../../../../../commons/components/runtime-context/connect'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {SeatsUnavailableRuntimeProps} from './interfaces'
import {SeatsUnavailable as Presentation} from './seats-unavailable'

const mapRuntime = ({actions: {clearReservationError}}: DetailsPageAppProps): SeatsUnavailableRuntimeProps => ({
  close: clearReservationError,
})

export const SeatsUnavailable = connect<{}, SeatsUnavailableRuntimeProps>(mapRuntime)(Presentation)
